import { defineStore } from "pinia";
import Services from '@/services/sutting/regionsServices'
import { mapList, mapList2Level, mapRegion } from '@/helpers/mapFuncs'

export const useRegionsStore = defineStore("regions", {
persist: true,
state:()=>({
    region: {},
    regions: [],
}),
getters : {
    getRegion() {
        return mapRegion(this.region)
    },
    getRegions() {
        return this.regions.map(mapRegion)
    },
    getRegionsList() {
        return this.regions.map(mapList)
    },
    getRegionsList2Level() {
        return this.regions.map(mapList2Level)
    }
},
actions : {
    /** Start Sets */
    setRegion(region) {
        this.region = region
    },
    setRegions(regions) {
        this.regions = regions
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setRegion(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setRegions(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.regions.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.regions[this.regions.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.regions = this.regions.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
